exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#html_inform a {\n  color: #00ab84 !important;\n}", ""]);

// exports
